// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"4449f116","251":"db6b7226","517":"58fc58b9","791":"9f8a97b6","888":"c61120a2"}[chunkId] + ".chunk.css";
};